import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { bomInstructionDescriptionSchema, bomInstructionDetailsSchema, bomInstructionNameSchema, } from './instruction-form.js';
export const addBomInstructionInputSchema = z.object({
    bomId: requiredUuidString('BOM is required.', 'Invalid BOM selection.'),
    name: bomInstructionNameSchema,
    details: bomInstructionDetailsSchema,
    description: bomInstructionDescriptionSchema,
    sortOrder: z.number().int().positive(),
});
//# sourceMappingURL=add-instruction-input.js.map